<!-- ================================== -->
<!-- Terms & Condition Banner start here... -->
<!-- ================================== -->
<section class="inhoused">
  <div class="max-width-container">
    <div class="container position-relative z-3">
      <h1>Terms and Conditions</h1>
      <p class="fw-bold">Effective Date: 23 April 2025</p>
      <p>
        Welcome to <a href="http://reali.au/" role="button" class="btn btn-link d-inline-flex px-0">Reali - Because
          Uniforms Matter .</a>
        This website is operated by <strong>
          Chicago Apparel Pty Ltd A.C.N. 148 998
          029 as trustee for One Stop Workwear Unit Trust trading as Reali Supply
        </strong> (ABN 72 360 818 347). By accessing or
        using our website, you agree to be bound by the following Terms and Conditions.
      </p>
    </div>
  </div>
</section>
<!-- ================================= -->
<!-- Terms & Condition Banner end here... -->
<!-- ================================== -->

<!-- ================================= -->
<!-- Terms & Condition content start here... -->
<!-- ================================== -->
<section class="about-ship-delivery">
  <div class="max-width-container">
    <div class="container">
      <div class="conditions">
        <h2>1. Business Use Only</h2>
        <ul class="list-condition">
          <li>
            <p>
              Reali Supply is a B2B-only provider. All purchases made through this site are intended for business use
              and not for personal or consumer purposes.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>2. Products and Services</h2>
        <ul class="list-condition">
          <li>
            <p>
              We sell branded workwear, footwear, PPE, and safety equipment across Australia and New Zealand. All
              products are subject to availability and may be changed or removed without prior notice.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>3. Orders, Pricing & Fees</h2>
        <ul class="list-condition">
          <li>
            <p>Minimum order value: Orders under <strong>$250 ex GST</strong> will incur a <strong>$20 Freight and Handling Fee.</strong></p>
          </li>
          <li>
            <p>
              Shipping: A flat shipping rate of <strong>$20</strong> applies to all orders.
            </p>
          </li>
          <li>
            <p>
              Prices and product information are subject to change at any time without notice.
            </p>
          </li>
          <li>
            <p>
              Reali Supply reserves the right to cancel or refuse orders at our discretion.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>4. Delivery</h2>
        <ul class="list-condition">
          <li>
            <p>
              Standard delivery time is <strong>7–9 business days</strong>, though this may vary by client or location.
              While we aim to
              meet delivery estimates, we are not liable for delays caused by third parties, natural events, or
              unforeseen circumstances.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>5. Returns & Refunds</h2>
        <ul class="list-condition">
          <li>
            <p>
              Returns are accepted for <strong>non-custom, non-embroidered items</strong> only.
            </p>
          </li>
          <li>
            <p>
              Return requests must be made <strong>within 15 days</strong> of receiving your order.
            </p>
          </li>
          <li>
            <p>
              Approved returns will be eligible for a refund to the original payment method.
            </p>
          </li>
          <li>
            <p>
              Customised or embroidered items <strong>cannot be returned</strong> unless faulty.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>6. Payment Terms</h2>
        <ul class="list-condition">
          <li>
            <p>
              We accept <strong>credit card</strong> and <strong>invoice terms</strong> by prior agreement.
            </p>
          </li>
          <li>
            <p>
              Invoice terms are granted at our discretion; <strong>no late payment fees</strong> are charged, but
              failure to pay may result in account suspension or cancellation.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>7. Customisation & Artwork</h2>
        <ul class="list-condition">
          <li>
            <p>
              Clients must <strong>approve all artwork</strong> prior to production.
            </p>
          </li>
          <li>
            <p>
              Once artwork is approved, <strong>no changes can be made</strong>.
            </p>
          </li>
          <li>
            <p>
              Reali Supply owns the final artwork files used for branding. Clients retain ownership of their logos and
              brand assets.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>8. Sizing, Colours & Care</h2>
        <ul class="list-condition">
          <li>
            <p>
              Variations in sizing and colours may occur due to manufacturing tolerances.
            </p>
          </li>
          <li>
            <p>
              We recommend reviewing product specifications and size guides prior to ordering.
            </p>
          </li>
          <li>
            <p>
              Care instructions are provided with each item. Reali Supply is not liable for damage resulting from
              improper garment care.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>9. Liability & Disclaimers</h2>
        <p class="mb-4">
          To the extent permitted by law, Reali Supply is not liable for:
        </p>
        <ul class="list-condition">
          <li>
            <p>
              Indirect or consequential losses;
            </p>
          </li>
          <li>
            <p>
              Incorrect sizing or colour variation;
            </p>
          </li>
          <li>
            <p>
              Delayed deliveries;
            </p>
          </li>
          <li>
            <p>
              Misuse of products or non-compliance with care/PPE instructions.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>10. Intellectual Property</h2>
        <ul class="list-condition">
          <li>
            <p>
              All content on this site, including designs, logos, and product descriptions, is the property of Reali
              Supply and may not be reproduced without permission.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>11. SUMS Platform Access</h2>
        <ul class="list-condition">
          <li>
            <p>
              Access to SUMS (Safety Uniform Management System) is provided upon approval of a signed credit
              application.
            </p>
          </li>
          <li>
            <p>
              Reali Supply provides user accounts with <strong>two-factor authentication</strong> and <strong>SSO
                (Single Sign-On)</strong> support.
            </p>
          </li>
          <li>
            <p>
              Users are responsible for maintaining account security. Reali Supply is not liable for unauthorised access
              due to user negligence.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>12. Modifications & Termination</h2>
        <p class="mb-4">
          We reserve the right to:
        </p>
        <ul class="list-condition">
          <li>
            <p>
              Change these Terms at any time without notice;
            </p>
          </li>
          <li>
            <p>
              Modify or discontinue products or features;
            </p>
          </li>
          <li>
            <p>
              Suspend or terminate site or SUMS access for any reason, including breach of terms.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>13. Privacy</h2>
        <ul class="list-condition">
          <li>
            <p>
              We collect and store personal information via contact forms, order checkout, and SUMS platform access.
              Please refer to our <a [routerLink]="['/privacy-policy']" role="button" class="btn btn-link d-inline-flex px-0">Privacy Policy</a>
              for details on how we handle and protect your data.
            </p>
          </li>
        </ul>
      </div>
      <div class="conditions">
        <h2>14. Governing Law</h2>
        <ul class="list-condition">
          <li>
            <p>
              These Terms are governed by the laws of Queensland, Australia. Any disputes arising from these Terms will
              be subject to the exclusive jurisdiction of the courts in that region.
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
<!-- ================================= -->
<!-- Terms & Condition content end here... -->
<!-- ================================== -->